import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { AdminUserService } from 'src/app/components/users/services/admin-user.service';
import { DisciplinedService } from '../../services/disciplined.service';
import { ModalDialogComponent } from './modal-dialog.component';
import { ModalDialogService } from './modal-dialog.service';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [ModalDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  providers: [
    ModalDialogService,
    AdminUserService,
    DisciplinedService
  ],
  exports: [ModalDialogComponent],
})
export class ModalDialogModule { }
